export default from './search-input';



// WEBPACK FOOTER //
// ./app/components/search-input/index.js